
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from "./router";
import VueCarousel from 'vue-carousel';
import VueScrollTo from 'vue-scrollto'
import VueImgLoader from 'vue-img-loader';
import VueMeta from 'vue-meta';
import vSelect from 'vue-select'
import store  from './store/index';
import { VueReCaptcha } from "vue-recaptcha-v3";



Vue.use(VueReCaptcha, { siteKey: "6LenTnIfAAAAAIt-h0tZfFXXOjz9vVca_19tofN1" });



Vue.component('v-select', vSelect)
Vue.use(VueScrollTo,{
  offset:-125
})
Vue.use(VueCarousel);
Vue.config.productionTip = false
Vue.use(VueMeta)



new Vue({
  router,
  i18n,
  store,
  'vue-img-loader': VueImgLoader,
  render: h => h(App),
}).$mount('#app')

